import { render } from "./findPWD.vue?vue&type=template&id=1a08ac46"
import script from "./findPWD.vue?vue&type=script&lang=js"
export * from "./findPWD.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__